// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class StickyHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.handlePageScroll = this.handlePageScroll.bind(this);
  }

  didMount() {
    this.target = document.querySelector('.order-container__form-container');
    window.addEventListener('scroll', this.handlePageScroll);
  }

  handlePageScroll() {
    let windowPosition = window.pageYOffset;
/*    let direction = this.oldOffset > windowPosition;
    this.oldOffset = windowPosition;*/

    if (windowPosition >= (this.target.offsetTop + this.target.offsetHeight)) {
      this.element.classList.remove('hidden');
    } else {
      // if (!direction) {
        this.element.classList.add('hidden');
      // }
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/StickyHandler.js